<template>
    <sui-form @submit="onSubmit">
        <GlobalConfig fetchMethod="LOCAL_FTP" />

        <div v-if="this.isUpdate">
            <h2 is="sui-header">{{ $t('gateway.ftp.localTitle') }}</h2>

            <sui-form-field>
                <sui-checkbox
                    label="Compte FTP partagé"
                    v-model="activeGateway.configuration.localFTPConfiguration.isGlobalFTPAccount"
                    disabled
                />
            </sui-form-field>

            <sui-form-fields :fields="'three'">
                <sui-form-field>
                    <label>{{ $t('common.id') }}</label>
                    <input
                        type="text"
                        readonly
                        :value="activeGateway.configuration.localFTPConfiguration.login"
                    />
                </sui-form-field>

                <sui-form-field>
                    <label>{{ $t('common.password') }}</label>
                    <input
                        type="text"
                        readonly
                        :value="activeGateway.configuration.localFTPConfiguration.secret"
                    />
                </sui-form-field>

                <sui-form-field>
                    <label>{{ $t('common.folder') }}</label>
                    <input
                        type="text"
                        readonly
                        :value="activeGateway.configuration.localFTPConfiguration.directory"
                    />
                </sui-form-field>
            </sui-form-fields>

            <a
                :href="ftpConnectionString"
                class="ui right labeled icon button"
                target="_blank"
                rel="noopener noreferrer"
            >
                <i class="external square alternate icon"></i>{{ $t('gateway.ftp.ftpView') }}
            </a>

            <sui-divider section />
        </div>

        <FileConfig fetchMethod="LOCAL_FTP" />
        <MediaConfig fetchMethod="LOCAL_FTP" />

        <sui-button color="violet" fluid>{{ $t('common.save') }}</sui-button>
    </sui-form>
</template>

<script>
    import GlobalConfig from '@/components/gateway/fields/GlobalConfig.vue';
    import FileConfig from '@/components/gateway/fields/FileConfig.vue';
    import MediaConfig from '@/components/gateway/fields/MediaConfig.vue';
    import store from '@/store';
    import { mapGetters } from 'vuex';

    export default {
        name: 'LocalFTPForm',
        components: {
            GlobalConfig,
            FileConfig,
            MediaConfig,
        },
        computed: {
            ...mapGetters(['activeGateway']),
            state: {
                get() { return store.state; }
            },
            ftpConnectionString: {
                get() {
                    const { login, secret } = this.activeGateway.configuration.localFTPConfiguration;
                    return `ftp://${login}:${secret}@${process.env.VUE_APP_FTP_DOMAIN}`;
                }
            }
        },
        props: {
            fetchMethod: String,
            isUpdate: Boolean,
            onSubmit: Function,
        },
    }
</script>